export const deliveryNotes = (state) => state.deliveryNotes
export const selectAllField = (state) => state.selectAllField
export const getTemplateId = (state) => state.deliveryNoteTemplateId
export const selectedDeliveryNotes = (state) => state.selectedDeliveryNotes
export const totalDeliveryNotes = (state) => state.totalDeliveryNotes
export const selectedCustomer = (state) => state.selectedCustomer

export const deliveryNoteItems = (state) => state.deliveryNoteItems
export const selectAllFieldItem = (state) => state.selectAllFieldItem
export const selectedDeliveryNoteItems = (state) => state.selectedDeliveryNoteItems
export const POItems = (state) => state.POItems
export const availableDeliveryNoteItems = (state) => state.availableDeliveryNoteItems
export const deliveryNoteItemsStatus = (state) => state.deliveryNoteItemsStatus
export const POHasItems = (state) => state.POHasItems

